import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../core/common/imageWithBasePath'
import { all_routes } from '../router/all_routes'

interface BannerProps {
    apiValues5: any;
}



const Becomeinstructor: React.FC<BannerProps> = ({ apiValues5 }) => {

    const route = all_routes
    return (
        <>
            {/* Become An Instructor */}
            <div className="section become-instructors aos mb-4">
                {/* <ImageWithBasePath
                    src="assets/img/bg/bg-5.png"
                    alt=""
                    className="img-fluid become-instructors-bg1"
                />
                <ImageWithBasePath
                    src="assets/img/bg/bg-6.png"
                    alt=""
                    className="img-fluid become-instructors-bg2"
                /> */}
                <div className="container">
                    <div className="row row-gap-3">
                        {
                            (Array.isArray(apiValues5) ? apiValues5 : []).map((item: any, index: number) => {
                                return (

                                    <div className="col-md-6 d-flex">
                                        <div className="student-mentor d-flex flex-fill">
                                            <div className="row ">
                                                <div className="col-lg-8 col-md-12">
                                                    <div className="top-instructors">
                                                        <h4>

                                                            {item?.title}
                                                        </h4>
                                                        <p>
                                                            {item?.description}


                                                        </p>
                                                        <Link
                                                            to={index == 0 ? "/Contact" : "/unlock"}

                                                            className="btn btn-secondary btn-xl"
                                                        >
                                                            {item?.buttonText}

                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-12">
                                                    <div className="">
                                                        {/* <ImageWithBasePath
                                                            className="img-fluid d-none d-lg-flex"
                                                            alt="Img"
                                                            src="assets/img/feature/feature-15.svg"
                                                        /> */}

                                                        <ImageWithBasePath
                                                            source={
                                                                item?.imageUrl
                                                            }
                                                            className="img-fluid d-none d-lg-flex"
                                                            // height={40}
                                                            // width={40}
                                                            alt="Img"
                                                        style={{
                                                            maxHeight:200
                                                        }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) || []
                        }
                
                    </div>
                </div>
            </div>
        </>

    )
}

export default Becomeinstructor
